export default __webpack_public_path__ + "static/media/66.f88bea2a.png";